import { IProps } from 'component/Calendar/DateCeil';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connectSeewoIM, disconnectSeewoIM } from 'lib/seewoIm';
import { RootState } from 'model';
import ScheduleProvider from './Provider/ScheduleProvider';
import ContainerView from './components/ContainerView';

const MeetingSchedule: React.FC<IProps> = () => {
  const staffId = useSelector((state: RootState) => state.user.userInfo?.staffId);

  useEffect(() => {
    connectSeewoIM().catch((error) => {
      console.warn('[seewo-im] connect failed', error);
    });
    return () => {
      disconnectSeewoIM();
    };
  }, [staffId]);

  return (
    <ScheduleProvider>
      <ContainerView />
    </ScheduleProvider>
  );
};

export default MeetingSchedule;
